import { isServer, parsedUrl } from '@verifime/utils';
import { isDate, parse, parseISO } from 'date-fns';

/**
 * The active organisation id, read from the URL query. This app keys its pages
 * by `?orgId=`; components normally read it via `router.query.orgId`, but the
 * error boundary is a class component with no router hook, so it uses this
 * helper against the raw URL instead. Never throws; null when unavailable.
 */
export function getOrgIdFromUrl(): string | null {
  if (isServer) return null;
  return parsedUrl().urlParams.get('orgId');
}

export function parseDateString(_: string, originalValue: string) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, 'yyyy-MM-dd', new Date());
  return parsedDate;
}

export function parseISODateString(_: string, originalValue: string) {
  return isDate(originalValue) ? originalValue : parseISO(originalValue);
}

/**
 *
 * Generate random string
 *
 * @param type available values are `number` and `string`, default is `number`.
 * 1. if the `number` type given, the generated string are all number
 * 2. if the `string` type given, the generated string are mix of number and letters
 *
 * @param length The length of generated string, default length is 5.
 */
export function getRandomString(type: 'number' | 'string', length = 5) {
  const radix = type === 'number' ? 10 : 36;
  return (Math.random() + 1).toString(radix).slice(2, length + 2);
}
